import React from "react";
import styles from "./ContentToLink.module.css";
import { SENTENCE_TYPE } from "../../../../../../../constants/constants";
import { CustomIconButton, Hierarchy, icon } from "../../../../../../../../../common/components";
import { dangerousSetInnerHTML } from "../../../../../../../../../common/utils";

const spanRegex = /<\/?span[^>]*>/g;

const ContentToLink = ({
	content,
	className,
	isSelectedResult,
	onClose = null,
	informationText = "",
	onCheckSelectedContent = null,
}) => {
	const { content: text, documentName, informationId, location, type } = content;
	const removeSpanTags = (spanText) => (spanText ? spanText.replace(spanRegex, "") : "");
	const selectedContent = isSelectedResult ? removeSpanTags(text) : dangerousSetInnerHTML({ text });
	return (
		<div className={`${styles.container} ${className}`}>
			<div>
				<div className={styles.rowId}>
					<div>
						{(type === SENTENCE_TYPE.INFORMATION && "INFO_") || "REQ_"}
						{informationId}
					</div>
					{typeof onCheckSelectedContent === "function" && onCheckSelectedContent(content) && (
						<div>{informationText}</div>
					)}
				</div>
				{onClose && typeof onClose === "function" && (
					<CustomIconButton
						btnClassName={styles.close}
						icon={icon.faTimes}
						iconColor="var(--grey-500)"
						onClick={onClose}
					/>
				)}
			</div>
			<div>
				<Hierarchy
					isDangerousSetInnerHTML
					breadcrumbClassName={styles.heriarchy}
					documentName={documentName}
					hierarchy={location}
				/>
			</div>
			<div>{selectedContent}</div>
		</div>
	);
};

export default ContentToLink;
